export const ACTIVE_YEAR = parseInt(process.env.GATSBY_TAX_YEAR || '') || 2025

export const ACCESS_TOKEN = 'accessToken'

export const postcodeRegex = new RegExp(/^[0-9]{4}\s*[a-zA-Z]{2}\s?$/)

